"use client";

import { ArrowRight } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { GRID_CLASSES } from "@/libs/grid/grid";

const services = [
  {
    title: "Farm Equipment Solutions",
    description: "Reliable equipment to improve productivity across every stage of farming.",
    href: "/our-services/farm-equipment-solutions",
    image: "/images/services/farm-equipment.jpg",
  },
  {
    title: "Water Pump Solutions",
    description: "Dependable pumping solutions for irrigation, homes, businesses, and industry.",
    href: "/our-services/water-pump-solutions",
    image: "/images/services/water-pump.jpg",
  },
  {
    title: "Generator Solutions",
    description: "Reliable power solutions that keep homes, businesses, and projects running.",
    href: "/our-services/generator-solutions",
    image: "/images/services/generator.jpg",
  },
  {
    title: "Genuine Spare Parts",
    description: "Original replacement parts that help maximize equipment performance and lifespan.",
    href: "/our-services/genuine-spare-parts",
    image: "/images/services/spare-parts.jpg",
  },
];

export default function Services() {
  return (
    <section className="w-full bg-primary py-16 md:py-24">
      <div className={`text-white ${GRID_CLASSES}`}>

        {/* Heading */}
        <div className="col-span-6 md:col-start-3 md:col-span-8 text-center">
          <h2 className="text-3xl font-semibold tracking-tight md:text-5xl">
            Everything you need to keep work moving.
          </h2>
          <p className="mt-4 md:mt-6 text-base md:text-xl leading-7 md:leading-8">
            From farm equipment and water pumps to generators and genuine spare parts, explore practical solutions designed for the way you work.
          </p>
        </div>

        {/* Cards */}
        <div className="col-span-6 md:col-span-12 mt-12 md:mt-16 grid gap-6 md:gap-8 sm:grid-cols-2 md:grid-cols-4">
          {services.map((service) => (
            <Link
              key={service.title}
              href={service.href}
              className="group overflow-hidden rounded-3sm bg-neutral-100"
            >
              <div className="relative h-80 md:h-120 overflow-hidden">
                <Image
                  src={service.image}
                  alt={service.title}
                  fill
                  className="object-cover transition duration-700 group-hover:scale-105"
                  sizes="(max-width: 640px) 100vw, (max-width: 768px) 50vw, 25vw"
                />
                <div className="absolute inset-0 bg-linear-to-t from-black/80 via-black/30 to-transparent" />
                <div className="absolute bottom-0 flex w-full flex-col gap-3 md:gap-4 p-6 md:p-8 text-white">
                  <h3 className="text-2xl md:text-3xl font-semibold">{service.title}</h3>
                  <p className="max-w-md text-white/85 text-sm md:text-base">{service.description}</p>
                  <span className="inline-flex items-center gap-2 font-medium">
                    Explore Solution
                    <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}